import React from 'react';
import clsx from 'clsx';
import styles from './Icon.module.scss';

const Icon = ({
  children,
  size = '1em',
  decorative = true,
  title,
  className,
  ...props
}) => {
  const ariaProps = decorative
    ? { 'aria-hidden': true }
    : { role: 'img', 'aria-label': title };

  return (
    <svg
      className={clsx(styles.icon, className)}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      {...ariaProps}
      {...props}
    >
      {!decorative && title && <title>{title}</title>}
      {children}
    </svg>
  );
};

export default Icon;
